import React from 'react';
import AllNews from './AllNews';

const Home = () => {
  return <> 
  <AllNews/>
        </>
  };

export default Home;
